import { SUCCESS } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

export const initialState = {
  activeAnnouncement: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_ACTIVE_ANNOUNCEMENT[SUCCESS]:
      return { ...state, activeAnnouncement: action.data };
    default:
      return state;
  }
};

export default reducer;
